module.exports = __webpack_public_path__ + "afd645e5b977c52736ebe9ecf6d5b5c0.svg";